<template>
  <v-container fluid style="height: calc(100vh - 64px)">
    <v-row style="height: 100%" v-if="isFetched">
      <v-col cols="4" class="pt-0 pb-0 pr-0">
        <v-card style="height: 100%">
          <v-row no-gutters>
            <span class="headline pa-3">{{ $i18n.t(`settings.layersList.title`) }}</span>
          </v-row>
          <div style="height: calc(100vh - 132px)" v-bar>
            <div>
              <v-row no-gutters class="layers-list__row">
                <v-col>
                  <v-list>
                    <v-subheader class="primary--text layerGroup__title">{{
                      $i18n.t('settings.systemLayers')
                    }}</v-subheader>
                    <template v-for="(layer, index) in systemLayers">
                      <v-list-item :key="index">
                        <v-list-item-content>
                          <v-list-item-title>{{ layer[`name_${$i18n.locale}`] }}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-btn icon @click="openDialog('layers', layer)">
                            <v-icon color="grey lighten-1">mdi-settings-outline</v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-col>
              </v-row>
              <v-row no-gutters class="layers-list__row">
                <v-col>
                  <v-list>
                    <v-subheader class="primary--text layerGroup__title">
                      <span>
                        {{ $i18n.t('settings.wmsLayers') }}
                        <v-btn
                          class="mx-1"
                          fab
                          x-small
                          dark
                          color="primary"
                          @click="openDialog('wms')"
                          :title="$i18n.t('settings.addingWMS')"
                        >
                          <v-icon dark>mdi-map-plus</v-icon>
                        </v-btn>
                        <v-btn
                          class="mx-1"
                          fab
                          x-small
                          dark
                          color="primary"
                          @click="openDialog('wmsGroup')"
                          :title="$i18n.t('settings.createWmsGroup')"
                        >
                          <v-icon dark>mdi-folder-multiple-plus</v-icon>
                        </v-btn>
                      </span>
                    </v-subheader>
                    <wms-settings-list
                      :layers-groups="layersGroupsTreeView"
                      @deleteWmsGroup="deleteGroupConfirm"
                      @deleteWmsLayer="deleteLayerConfirm('Wms', $event)"
                      @editWmsGroup="openDialog('wmsGroup', $event)"
                      @editWmsLayer="showConfirmDialog"
                    />
                  </v-list>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col>
                  <v-list>
                    <v-subheader class="primary--text layerGroup__title">
                      <span>
                        {{ $i18n.t('settings.userLayers') }}
                        <v-btn
                          class="layerGroup__button"
                          x-small
                          fab
                          dark
                          color="primary"
                          @click="openDialog('userLayer')"
                          :title="$i18n.t('settings.addUserLayers')"
                        >
                          <v-icon dark>mdi-map-plus</v-icon>
                        </v-btn>
                      </span>
                    </v-subheader>
                    <template v-for="(layer, index) in userLayers">
                      <v-list-item :key="index">
                        <v-list-item-content>
                          <v-list-item-title>{{ layer[`name_${$i18n.locale}`] }}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-btn
                            icon
                            @click="openDialog('userLayerSettings', layer)"
                            :title="$i18n.t('settings.editUserLayerSettings')"
                          >
                            <v-icon color="grey lighten-1">mdi-settings-outline</v-icon>
                          </v-btn>
                          <!--
                      <v-btn icon>
                        <v-icon color="grey lighten-1">mdi-pencil</v-icon>
                      </v-btn>
                          -->
                          <v-btn icon>
                            <v-icon color="grey lighten-1" @click="deleteLayerConfirm('User', layer)"
                              >mdi-delete</v-icon
                            >
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col cols="4" class="pt-0 pb-0 pl-0">
        <v-card style="height: 100%">
          <v-row no-gutters class="ml-6">
            <span class="headline pa-3">
              {{ $i18n.t(`${this.isUserAdmin ? 'settings.users.usersTitle' : 'settings.users.userTitle'}`) }}
            </span>
          </v-row>
          <settings-users :users="getUsers" />
        </v-card>
      </v-col>
    </v-row>
    <template v-else>
      <v-col cols="12">
        <v-row no-gutters justify="center" align="center" style="height: 100%">
          <v-col cols="auto">
            <v-progress-circular indeterminate color="primary" />
          </v-col>
        </v-row>
      </v-col>
    </template>
    <AddWMSModal v-if="isWMSDialog" :dialog="isWMSDialog" @success="addedWMS" @cancel="canceled('wms')" />
    <AddUserLayerDialog :dialog="isUserLayerDialog" @success="addUserLayer" @cancel="canceled('userLayer')" />
    <LayersSettingsDialog
      ref="layersSettingsDialog"
      :dialog="isLayersSettingsDialog"
      :layer.sync="currentUserSystemLayerEdit"
      @success="saveUserSystemLayerSettings"
      @cancel="canceled('layers')"
    />
    <UserLayerSettingsDialog
      :dialog="isUserLayerSettingsDialog"
      :layer="currentUserSystemLayerEdit ? currentUserSystemLayerEdit : {}"
      @success="saveUserSystemLayerSettings"
      @cancel="canceled('userLayerSettings')"
    />
    <WmsGroupDialog
      :dialog="isWmsGroupDialog"
      :group="currentWmsGroup ? currentWmsGroup : {}"
      :not-assigned-wms-layers="notAssignedWmsLayers"
      @success="saveWmsGroup"
      @cancel="canceled('wmsGroup')"
    />
    <ConfirmDialog
      v-if="confirmDialogLoaded"
      :dialog="confirmDialogVisible"
      @success="changeWmsLayerName"
      @cancel="confirmDialogVisible = false"
    >
      <template v-slot:header>
        <h1>{{ $i18n.t(`dialog.header.changeLayerName`) }}</h1>
      </template>
      <template v-slot:content>
        <v-form ref="formWms">
          <v-row>
            <v-col>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="wms.name_pl"
                    :label="$i18n.t('default.titlePL')"
                    :rules="[required]"
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="wms.name_en"
                    :label="$i18n.t('default.titleEN')"
                    :rules="[required]"
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </template>
    </ConfirmDialog>
    <ConfirmDialog :dialog="confirmDeleteLayerDialog" @success="removeLayer" @cancel="confirmDeleteLayerDialog = false">
      <template v-slot:header>
        <h1>{{ $i18n.t(`dialog.header.deleteLayer`) }}</h1>
      </template>
      <template v-slot:content>
        <span>{{ deleteLayerContent }}</span>
      </template>
    </ConfirmDialog>
    <ConfirmDialog :dialog="confirmDeleteGroupDialog">
      <template v-slot:header>
        <h1>{{ $i18n.t(`dialog.header.deleteGroup`) }}</h1>
      </template>
      <template v-slot:content>
        <span>{{ $i18n.t('dialog.content.deleteGroup') }}</span>
      </template>
      <template v-slot:buttons>
        <v-btn
          color="primary"
          text
          @click="confirmDeleteGroupDialog = false"
        >{{ $i18n.t('dialog.confirmation.cancel') }}</v-btn>
        <v-btn
          color="primary"
          text
          @click="removeGroup"
        >{{ $i18n.t('dialog.confirmation.delete') }}</v-btn>
      </template>
    </ConfirmDialog>
  </v-container>
</template>

<script>
import AddUserLayerDialog from '@/components/settings/AddUserLayerDialog';
import LayersSettingsDialog from '@/components/settings/LayersSettingsDialog';
import SettingsUsers from '@/components/settings/SettingsUsers';
import UserLayerSettingsDialog from '@/components/settings/UserLayerSettingsDialog';

export default {
  name: 'Settings',
  components: {
    AddUserLayerDialog,
    LayersSettingsDialog,
    SettingsUsers,
    UserLayerSettingsDialog,
    AddWMSModal: () => import('@/components/settings/AddWMSModal'),
    ConfirmDialog: () => import('@/components/ConfirmDialog'),
    WmsGroupDialog: () => import('@/components/settings/WmsGroupDialog'),
    WmsSettingsList: () => import('@/components/settings/WmsSettingsList')
  },
  data: () => ({
    isFetched: false,
    wms: {
      name_pl: '',
      name_en: ''
    },
    editedLayer: undefined,
    confirmDeleteGroupDialog: false,
    confirmDeleteLayerDialog: false,
    confirmDialogLoaded: false,
    confirmDialogVisible: false,
    currentUserSystemLayerEdit: {},
    currentWmsGroup: {},
    isUserLayerDialog: false,
    isUserLayerSettingsDialog: false,
    isWMSDialog: false,
    isWmsGroupDialog: false,
    isLayersSettingsDialog: false,
    groupToDelete: {},
    layerToDelete: {}
  }),
  computed: {
    currentUser() {
      return this.$store.getters.getCurrentUser;
    },
    deleteLayerContent() {
      if (this.layerToDelete.layer) {
        const layerName =
          this.$i18n.locale === 'pl' ? this.layerToDelete.layer.name_pl : this.layerToDelete.layer.name_en;
        return this.$i18n.t(`dialog.content.deleteLayer`) + ' ' + layerName + '?';
      }
      return '';
    },
    getUsers() {
      return this.isUserAdmin ? this.users : [this.currentUser];
    },
    isUserAdmin() {
      return this.$store.getters.getIsAdmin === 'true' || this.$store.getters.getIsAdmin === true;
    },
    layersGroups() {
      return this.$store.getters.getLayersGroups;
    },
    layersGroupsTreeView() {
      const treeView = [];
      for (const group of this.layersGroups) {
        const groupItem = group;
        groupItem.children = [];
        for (const layer of groupItem.layers || []) {
          const wmsLayer = this.wmsLayers.find(wmsLayer => wmsLayer.id === layer);
          groupItem.children.push(wmsLayer);
        }
        treeView.push(groupItem);
      }
      return treeView.concat(this.notAssignedWmsLayers);
    },
    notAssignedWmsLayers() {
      const notAssignedWmsLayers = [];
      for (const wmsLayer of this.wmsLayers) {
        if (this.layersGroups.find(group => group.layers && group.layers.includes(wmsLayer.id))) {
          continue;
        }
        notAssignedWmsLayers.push(wmsLayer);
      }
      return notAssignedWmsLayers;
    },
    wmsLayers() {
      return this.$store.getters.getWMSLayers;
    },
    users() {
      return this.$store.getters.getUsersList;
    },
    userLayers() {
      return this.$store.getters.getUserLayersList;
    },
    systemLayers() {
      return this.$store.getters.getSystemLayers;
    },
    required() {
      return v => !!v || this.$i18n.t('default.requiredField');
    }
  },
  methods: {
    async addUserLayer(payload) {
      try {
        await this.$store.dispatch('addLayer', payload).then(async () => {
          await this.getLayers();
          this.$root.$emit('showSnackbar', this.$i18n.t(`settings.addSuccess`));
          this.isUserLayerDialog = false;
        });
      } catch (error) {
        this.$root.$emit('showSnackbar', error);
        this.isUserLayerDialog = false;
      }
    },
    addedWMS() {
      this.isWMSDialog = false;
    },
    async changeWmsLayerName() {
      if (this.$refs.formWms.validate()) {
        try {
          const response = await this.$store.dispatch('editLayer', {
            id: this.editedLayer.id,
            body: this.wms
          });
          this.$root.$emit('showSnackbar', this.$i18n.t(`settings.editSuccess`));
          const { name_en, name_pl } = this.wms;
          this.editedLayer.name_pl = name_pl;
          this.editedLayer.name_en = name_en;
          this.confirmDialogVisible = false;
          this.editedLayer = undefined;
        } catch (error) {
          this.$root.$emit('showSnackbar', error);
        }
      }
    },
    canceled(dialogType) {
      if (dialogType == 'wms') {
        this.isWMSDialog = false;
      } else if (dialogType == 'layers') {
        this.isLayersSettingsDialog = false;
        this.currentUserSystemLayerEdit = {};
      } else if (dialogType === 'userLayerSettings') {
        this.isUserLayerSettingsDialog = false;
        this.currentUserSystemLayerEdit = {};
      } else if (dialogType === 'wmsGroup') {
        this.isWmsGroupDialog = false;
        this.currentWmsGroup = {};
      } else {
        this.isUserLayerDialog = false;
      }
    },
    openDialog(dialogType, layer) {
      if (dialogType == 'wms') {
        this.isWMSDialog = true;
      } else if (dialogType == 'layers') {
        this.currentUserSystemLayerEdit = JSON.parse(JSON.stringify(layer));
        this.isLayersSettingsDialog = true;
      } else if (dialogType === 'userLayerSettings') {
        this.currentUserSystemLayerEdit = JSON.parse(JSON.stringify(layer));
        this.isUserLayerSettingsDialog = true;
      } else if (dialogType === 'wmsGroup') {
        if (layer && layer.children) {
          delete layer.children;
        }
        this.currentWmsGroup = layer ? JSON.parse(JSON.stringify(layer)) : { name_pl: '', name_en: '', layers: [] };
        this.isWmsGroupDialog = true;
      } else {
        this.isUserLayerDialog = true;
      }
    },
    deleteGroupConfirm(group) {
      this.groupToDelete = group;
      this.confirmDeleteGroupDialog = true;
    },
    deleteLayerConfirm(type, layer) {
      this.layerToDelete = { type: type, layer: layer };
      this.confirmDeleteLayerDialog = true;
    },
    removeGroup(deleteLayers = false) {
      this.$store.dispatch('deleteLayerGroup', {id: this.groupToDelete.id, deleteLayers}).then(async r => {
        if (deleteLayers) {
          await this.getLayers();
        }
        if (r.status === 200 || r.status === 204) {
          this.$root.$emit('showSnackbar', this.$i18n.t(`settings.deleteGroupSuccess`));
          this.confirmDeleteGroupDialog = false;
        }
      });
    },
    removeLayer() {
      const layer = this.layerToDelete.layer;
      const type = this.layerToDelete.type;
      this.$store.dispatch('deleteLayer', layer.id).then(r => {
        if (r.status === 200 || r.status === 204) {
          this.$root.$emit('showSnackbar', this.$i18n.t(`settings.deleteSuccess`));
          this[`${type.toLowerCase()}Layers`];
          this.$store.commit(
            `set${type}List`,
            this[`${type.toLowerCase()}Layers`].filter(l => l.id !== layer.id)
          );
          this.confirmDeleteLayerDialog = false;
        }
      });
    },
    async saveUserSystemLayerSettings() {
      const layerId = this.currentUserSystemLayerEdit.id;
      const payload = { style: this.currentUserSystemLayerEdit.style, id: layerId };
      if (this.currentUserSystemLayerEdit.layer_type === 'user') {
        payload.name_pl = this.currentUserSystemLayerEdit.name_pl;
        payload.name_en = this.currentUserSystemLayerEdit.name_en;
      }
      await this.$store
        .dispatch('editUserSystemLayer', payload)
        .then(async r => {
          if (r.status === 200 || r.status === 204) {
            await this.getLayers();
            this.$root.$emit('showSnackbar', this.$i18n.t('settings.layerEditSuccess'));
          } else {
            this.$root.$emit('showSnackbar', this.$i18n.t('settings.layerEditError'));
          }
        })
        .catch(error => {
          this.$root.$emit('showSnackbar', error);
        });
      this.currentUserSystemLayerEdit = {};
      this.isUserLayerSettingsDialog = false;
      this.isLayersSettingsDialog = false;
    },
    async saveWmsGroup() {
      const actionName =
        this.currentWmsGroup && (this.currentWmsGroup.id || this.currentWmsGroup.id == '0')
          ? 'editLayersGroup'
          : 'addLayersGroup';
      await this.$store
        .dispatch(actionName, this.currentWmsGroup)
        .then(r => {
          if (r.status === 200 || r.status === 201 || r.status === 204) {
            this.$root.$emit('showSnackbar', this.$i18n.t(`settings.${actionName}Success`));
          } else {
            this.$root.$emit('showSnackbar', this.$i18n.t(`settings.${actionName}Error`));
          }
        })
        .catch(error => {
          this.$root.$emit('showSnackbar', error);
        });
      this.currentWmsGroup = {};
      this.isWmsGroupDialog = false;
    },
    showConfirmDialog(layer) {
      const { name_pl, name_en } = layer;
      this.wms = { name_pl, name_en };
      this.editedLayer = layer;
      this.confirmDialogLoaded = true;
      this.confirmDialogVisible = true;
    },
    async getLayers() {
      await this.$store.dispatch('getLayers').then(r => {
        if (r.status === 200 && r.data.layers.length > 0) {
          const wmsLayers = r.data.layers
            .filter(layer => layer.wms_layers)
            .map(layer => {
              layer.wms_layers = layer.wms_layers.split(',');
              return layer;
            });
          const userLayers = r.data.layers.filter(layer => layer.layer_type === 'user');
          const systemLayers = r.data.layers.filter(layer => layer.layer_type === 'system');
          this.$store.commit('setWmsList', wmsLayers);
          this.$store.commit('setUserList', userLayers);
          this.$store.commit('setSystemList', systemLayers);
        }
      });
    },
    async init() {
      try {
        await this.getLayers();
        await this.$store.dispatch('getLayersGroups');
        await this.$store.dispatch('getUsers');
        this.isFetched = true;
      } catch {
        this.isFetched = true;
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style lang="scss">
html {
  overflow: hidden;
}
.layerGroup__title {
  font-size: 1.2em;
  font-weight: 500;
}
.v-list-item__action--stack {
  flex-direction: row;
}
.layers-list__row {
  border-bottom: 1px solid lightgrey;
}
</style>
